import { render, staticRenderFns } from "./EnhancedMessageInput.vue?vue&type=template&id=0ab0774a&scoped=true&"
import script from "./EnhancedMessageInput.vue?vue&type=script&lang=js&"
export * from "./EnhancedMessageInput.vue?vue&type=script&lang=js&"
import style0 from "./EnhancedMessageInput.vue?vue&type=style&index=0&id=0ab0774a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab0774a",
  null
  
)

export default component.exports